// src/pages/employee/AddEmployee.jsx

import React, { useState, useRef, useEffect } from 'react';
import { Info, CloudUpload, X, ChevronDown, Search } from 'lucide-react';
import { useHistory } from "react-router-dom";
import Tooltip from '../addentities/Tooltip.js';
import apiHelper from '../../apiHelper';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal.js';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import DatePicker from 'react-date-picker';
// import 'react-date-picker/dist/DatePicker.css';
// import 'react-calendar/dist/Calendar.css';

export default function AddEmployee() {
    const history = useHistory();
    const [uploadedImage, setUploadedImage] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const fileInputRef = useRef(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [validationError, setValidationError] = useState([]);
    // Add to the state declarations (after existing state variables)
    const [allJobTitles, setAllJobTitles] = useState([]);
    const [isJobTitleOpen, setIsJobTitleOpen] = useState(false);
    const [jobTitleSearch, setJobTitleSearch] = useState('');
    const [selectedJobTitle, setSelectedJobTitle] = useState(null);
    const jobTitleRef = useRef(null);

    const [allCountryCodes, setAllCountryCodes] = useState([]);
    const [isCountryCodeOpen, setIsCountryCodeOpen] = useState(false);
    const [countryCodeSearch, setCountryCodeSearch] = useState('');
    const [selectedCountryCode, setSelectedCountryCode] = useState({
    country_code_id: 'default_65',
    country_code: '+65',
    country_name: 'Singapore' // Optional, adjust based on API response
    });
    const countryCodeRef = useRef(null);
    const [disabled, setDisabled] = useState(false);
    const [formData, setFormData] = useState({
        profile_image: null,
        employee_first_name: '',
        employee_last_name: '',
        status: "1",
        display_name: '',
        permission_groups: [], 
        company_email : '',
        personal_email : '',
        country_code : '+65',
        phone_number : '',
        departments : [],
        manager : '',
        entities : [],
        workplaces : [],
        job_title : '',
        onboard_date : '',
        notes : '',
    });

    
    const [errors, setFormErrors] = useState({
        profile_image: '',
        employee_first_name: '',
        status: "1",
        company_email: '',
        phone_number : '',
        departments : '',
        manager : '',
        entities : '',
        workplaces : '',
        job_title : '',
        onboard_date : '',
        country_code: '',
    });

    useEffect(() => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          profile_image: uploadedImage
        }));
    }, [uploadedImage]);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleImageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setUploadedImage(e.target.files[0]);

            console.log("herer ",  e.target.files[0])
        }
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            setUploadedImage(e.dataTransfer.files[0]);
            e.dataTransfer.clearData();
        }
    };

    const handleBrowseClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleRemoveImage = () => {
        setUploadedImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const [allDepartments, setAllDepartments] = useState([
        { short_name: 'HQ', department_id: '1' },
        { short_name: 'Mister Mobile HQ', department_id: '2' },
        { short_name: 'Mister Mobile HQ 2', department_id: '3' },
    ]);

    const [selectManagers, setSelectManagers] = useState('');
    const [isDeptOpen, setIsDeptOpen] = useState(false);
    const [deptSearch, setDeptSearch] = useState('');
    const [selectedDepts, setSelectedDepts] = useState([]);
    const [selectedEntities, setSelectedEntities] = useState([]);
    const [selectedWorkplaces, setSelectedWorkplaces] = useState([]);
    const [selectedPermissionGroups, setSelectedPermissionGroups] = useState([]);

    const deptRef = useRef(null);
    const toggleDept = () => {
        setIsDeptOpen((prev) => !prev);
    };

    useEffect(() => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          departments: selectedDepts.map((item) => item.department_id)
        }));
    }, [selectedDepts]);
      
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isDeptOpen && deptRef.current && !deptRef.current.contains(e.target)) {
                setIsDeptOpen(false);
            }
            if (isJobTitleOpen && jobTitleRef.current && !jobTitleRef.current.contains(e.target)) {
            setIsJobTitleOpen(false);
            }
            if (isCountryCodeOpen && countryCodeRef.current && !countryCodeRef.current.contains(e.target)) {
                setIsCountryCodeOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDeptOpen]);

    const filteredDepts = allDepartments.filter((d) =>
        d.short_name.toLowerCase().includes(deptSearch.trim().toLowerCase())
    );

    const handleDeptCheckbox = (dept) => {
        const exists = selectedDepts.findIndex((item) => item.department_id === dept.department_id);
        if (exists > -1) {
            setSelectedDepts((prev) => prev.filter((item) => item.department_id !== dept.department_id));
        } else {
            setSelectedDepts((prev) => [...prev, dept]);
        }
    };

    const removeDept = (valueToRemove) => {
        setSelectedDepts((prev) =>
            prev.filter((item) => item.department_id !== valueToRemove)
        );
    };

    const [activeTab] = useState("Add Employee");
    const breadcrumbs = ["Organisations", "Employees", activeTab];

    const handleSave = async () => {
        setDisabled(true);
        let form_errors = { employee_first_name: '', short_name: '' };
        let is_error = false;
        if(!formData.profile_image){
            form_errors["profile_image"] = "This field is required!";
            is_error = true;
        }
        if(!formData.employee_first_name){
            form_errors["employee_first_name"] = "This field is required!";
            is_error = true;
        }
        if(!formData.company_email){
            form_errors["company_email"] = "This field is required!";
            is_error = true;
        }
        if(!formData.phone_number){
            form_errors["phone_number"] = "This field is required!";
            is_error = true;
           
        }
        if(!formData.manager){
            form_errors["manager"] = "This field is required!";
            is_error = true;
            
        }
        if(!formData.job_title){
            form_errors["job_title"] = "This field is required!";
            is_error = true;
        }
        if(!formData.onboard_date){
            form_errors["onboard_date"] = "This field is required!";
            is_error = true;
        }
        if(!formData.departments.length){
            form_errors["departments"] = "This field is required!";
            is_error = true;
        }
        if(!formData.entities.length){
            form_errors["entities"] = "This field is required!";
            is_error = true;
        }
        if(!formData.workplaces.length){
            form_errors["workplaces"] = "This field is required!";
            is_error = true;
            
        }
        setFormErrors(form_errors);

        console.log("is_error", is_error);
        if(is_error){
            setDisabled(false);
            setValidationError("Fail to be created");
            return false;
        }

        let postFormData = new FormData();
        Object.keys(formData).forEach(key => {
            if (Array.isArray(formData[key])) {
                postFormData.append(key, formData[key].join(','));
            } else if (formData[key] !== null && formData[key] !== undefined) {
                postFormData.append(key, formData[key]);
            }
        });

        const response = await apiHelper('users/create/', 'POST', postFormData, 'multipart/form-data');
        setDisabled(false);

        if (response) {
            if (response.ok) {
                setSuccessMessage('Employee created successfully.');
                setValidationError([]);
                setSelectedDepts([]);
                setSelectedEntities([]);
                setSelectedWorkplaces([]);
                setSelectedPermissionGroups([]);
                setUploadedImage(null);
                setSelectedJobTitle(null);
                setSelectedCountryCode(null);
                setFormData({
                    profile_image: null,
                    employee_first_name: '',
                    employee_last_name: '',
                    status: "1",
                    display_name: '',
                    permission_groups: [],
                    company_email: '',
                    personal_email: '',
                    country_code: '+65',
                    phone_number: '',
                    departments: [],
                    manager: '',
                    entities: [],
                    workplaces: [],
                    job_title: '',
                    onboard_date: '',
                    notes: '',
                });
                history.push('/employee', { success: "Employee created successfully" })
            } else if (response.status === 400) {
                const response_errors = await response.json();
                let errors = [];
                for (let i in response_errors) {
                    errors.push(`${i}: ${response_errors[i][0]}`);
                }
                setValidationError(errors);
                setSuccessMessage('');
            }
        }
    };

    const [discardModalOpen, setDiscardModalOpen] = useState(false);
        const discardRef = useRef(null);
                   const handleDiscard = () => {
                    setDiscardModalOpen(true);
                };
                const handleDiscardConfirm = (confirm) => {
                    if (confirm) {
                        history.goBack();
                    }
                    setDiscardModalOpen(false);
                };
                const handleCancelDiscard = () => {
                    setDiscardModalOpen(false);
                };
            useEffect(() => {
                function handleClickOutside(event) {
                    if (discardRef.current && !discardRef.current.contains(event.target)) {
                        setDiscardModalOpen(false);
                    }
                }
                if (discardModalOpen) {
                    document.addEventListener("mousedown", handleClickOutside);
                }
                return () => {
                    document.removeEventListener("mousedown", handleClickOutside);
                };
            }, [discardModalOpen]);

    const [allEntities, setAllEntities] = useState([
        { entity_short_name: 'HQ', entity_id: '1' },
        { entity_short_name: 'Mister Mobile HQ', entity_id: '2' },
        { entity_short_name: 'Mister Mobile HQ 2', entity_id: '3' },
    ]);
    const [isEntityOpen, setIsEntityOpen] = useState(false);
    const [entitySearch, setEntitySearch] = useState('');

    const entityRef = useRef(null);
    useEffect(() => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          entities: selectedEntities.map((item) => item.entity_id)
        }));
    }, [selectedEntities]);
    
    const toggleEntity = () => setIsEntityOpen((prev) => !prev);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isEntityOpen && entityRef.current && !entityRef.current.contains(e.target)) {
                setIsEntityOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isEntityOpen]);

    const filteredEntities = allEntities.filter((e) =>
        e.entity_short_name.toLowerCase().includes(entitySearch.trim().toLowerCase())
    );
    const handleEntityCheckbox = (entity) => {
        const exists = selectedEntities.findIndex((item) => item.entity_id === entity.entity_id);
        if (exists > -1) {
            setSelectedEntities((prev) => prev.filter((item) => item.entity_id !== entity.entity_id));
        } else {
            setSelectedEntities((prev) => [...prev, entity]);
        }
    };
    const removeEntity = (valueToRemove) => {
        setSelectedEntities((prev) => prev.filter((item) => item.entity_id !== valueToRemove));
    };

    // WORKPLACE MULTI-SELECT
    const [allWorkplaces, setAllWorkplaces] = useState([
        { short_name: 'HQ', workplace_id: '1' },
        { short_name: 'Mister Mobile HQ', workplace_id: '2' },
        { short_name: 'Mister Mobile HQ 2', workplace_id: '3' },
    ]);
    const [isWorkplaceOpen, setIsWorkplaceOpen] = useState(false);
    const [workplaceSearch, setWorkplaceSearch] = useState('');
    const workplaceRef = useRef(null);
    useEffect(() => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          workplaces: selectedWorkplaces.map((item) => item.workplace_id)
        }));
    }, [selectedWorkplaces]);

    const toggleWorkplace = () => setIsWorkplaceOpen((prev) => !prev);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isWorkplaceOpen && workplaceRef.current && !workplaceRef.current.contains(e.target)) {
                setIsWorkplaceOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isWorkplaceOpen]);

    const filteredWorkplaces = allWorkplaces.filter((w) =>
        w?.workplace_short_name?.toLowerCase().includes(workplaceSearch.trim().toLowerCase())
    );
    const handleWorkplaceCheckbox = (workplace) => {
        const exists = selectedWorkplaces.findIndex((item) => item.workplace_id === workplace.workplace_id);
        if (exists > -1) {
            setSelectedWorkplaces((prev) => prev.filter((item) => item.workplace_id !== workplace.workplace_id));
        } else {
            setSelectedWorkplaces((prev) => [...prev, workplace]);
        }
    };
    const removeWorkplace = (valueToRemove) => {
        setSelectedWorkplaces((prev) => prev.filter((item) => item.workplace_id !== valueToRemove));
    };
    const [allPermissionGroups, setAllPermissionGroups] = useState([
        { role_name: 'Admin', id: '1' },
        { role_name: 'Editor', id: '2' },
        { role_name: 'Viewer', id: '3' },
        { role_name: 'IT', id: '4' },
    ]);

    const [isPermissionGroupOpen, setIsPermissionGroupOpen] = useState(false);
    const [permissionGroupSearch, setPermissionGroupSearch] = useState('');
    
    const permissionGroupRef = useRef(null);
    useEffect(() => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          permission_groups: selectedPermissionGroups.map((item) => item.id)
        }));
    }, [selectedPermissionGroups]);

    const togglePermissionGroup = () => {
        setIsPermissionGroupOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                isPermissionGroupOpen &&
                permissionGroupRef.current &&
                !permissionGroupRef.current.contains(e.target)
            ) {
                setIsPermissionGroupOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isPermissionGroupOpen]);

    const filteredPermissionGroups = allPermissionGroups.filter((g) =>
        g.role_name.toLowerCase().includes(permissionGroupSearch.trim().toLowerCase())
    );

    const handlePermissionGroupCheckbox = (group) => {
        const exists = selectedPermissionGroups.findIndex((item) => item.id === group.id);
        if (exists > -1) {
            setSelectedPermissionGroups((prev) => prev.filter((item) => item.id !== group.id));
        } else {
            setSelectedPermissionGroups((prev) => [...prev, group]);
        }
    };

    const removePermissionGroup = (valueToRemove) => {
        setSelectedPermissionGroups((prev) =>
            prev.filter((item) => item.id !== valueToRemove)
        );
    };
    useEffect(() => {
    setFormData((prevFormData) => ({
        ...prevFormData,
        job_title: selectedJobTitle ? selectedJobTitle.job_title_id : '',
    }));
    }, [selectedJobTitle]);

    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            country_code: selectedCountryCode ? selectedCountryCode.country_code_id : '+65',
        }));
    }, [selectedCountryCode]);
    const toggleJobTitle = () => {
    setIsJobTitleOpen((prev) => !prev);
    };

    const handleJobTitleSelect = (jobTitle) => {
        setSelectedJobTitle(jobTitle);
        setIsJobTitleOpen(false);
    };

    const removeJobTitle = () => {
        setSelectedJobTitle(null);
    };

    const filteredJobTitles = allJobTitles.filter((jt) =>
        jt.job_title_name.toLowerCase().includes(jobTitleSearch.trim().toLowerCase())
    );

    const toggleCountryCode = () => {
        setIsCountryCodeOpen((prev) => !prev);
    };

    const handleCountryCodeSelect = (countryCode) => {
        setSelectedCountryCode(countryCode);
        setIsCountryCodeOpen(false);
    };

    const removeCountryCode = () => {
        setSelectedCountryCode(null);
    };

    const filteredCountryCodes = allCountryCodes.filter((cc) =>
        cc.country_name.toLowerCase().includes(countryCodeSearch.trim().toLowerCase())
    );
    useEffect(() => {
        async function fetchDepartmentsData() {
            const response = await apiHelper('departments/list/');
            if (response && response.ok) {
                const result = await response.json();
                setAllDepartments(result);
            }
        }
        async function fetchEntitiesData() {
            const response = await apiHelper('entities/list/');
            if (response && response.ok) {
                const result = await response.json();
                setAllEntities(result);
            }
        }
        async function fetchWorkplacesData() {
            const response = await apiHelper('entities/workplaces/');
            if (response && response.ok) {
                const result = await response.json();
                setAllWorkplaces(result);
            }
        }
        async function fetchPermissionGroupsData() {
            const response = await apiHelper('roles/list/');
            if (response && response.ok) {
                const result = await response.json();
                setAllPermissionGroups(result);
            }
        }
        async function fetchManagers() {
            const response = await apiHelper('users/managers/');
            if (response && response.ok) {
                const result = await response.json();
                console.log("result",result)
                setSelectManagers(result);
            }
        }
        async function fetchCountryCodesData() {
        try {
            const response = await apiHelper('settings/country-codes/list/');
            if (response && response.ok) {
                const result = await response.json();
                setAllCountryCodes(result);

                // Find +65 in the API response
                const defaultCountryCode = result.find(
                    (cc) => cc.country_code === '+65'
                );
                if (defaultCountryCode) {
                    setSelectedCountryCode({
                        country_code_id: defaultCountryCode.country_code_id,
                        country_code: defaultCountryCode.country_code,
                        country_name: defaultCountryCode.country_name
                    });
                    setFormData((prev) => ({
                        ...prev,
                        country_code: defaultCountryCode.country_code
                    }));
                } else {
                    // Retain default +65 if not found in API response
                    setSelectedCountryCode({
                        country_code_id: 'default_65',
                        country_code: '+65',
                        country_name: 'Singapore'
                    });
                    setFormData((prev) => ({
                        ...prev,
                        country_code: '+65'
                    }));
                }
            }
        } catch (error) {
            console.error('Failed to fetch country codes:', error);
            // Retain default +65 on error
            setSelectedCountryCode({
                country_code_id: 'default_65',
                country_code: '+65',
                country_name: 'Singapore'
            });
            setFormData((prev) => ({
                ...prev,
                country_code: '+65'
            }));
        }
    }
        // Existing fetch calls...
        async function fetchJobTitlesData() {
            const response = await apiHelper('users/job-titles/list/');
            if (response && response.ok) {
                const result = await response.json();
                setAllJobTitles(result);
            }
        }
        fetchJobTitlesData()
        fetchCountryCodesData();
        fetchManagers()
        fetchDepartmentsData();
        fetchEntitiesData();
        fetchWorkplacesData();
        fetchPermissionGroupsData();
    }, []);

    return (
        <>
            <div className="company-body main-company-body-inner">
                <div className="breadcrumb">
                    {breadcrumbs.map((crumb, index) => {
                        const isLast = index === breadcrumbs.length - 1;
                        return (
                            <span
                                key={index}
                                className={`breadcrumb-item ${crumb === "Employees" ? "clickable" : ""
                                    }`}
                                onClick={() => {
                                    if (crumb === "Employees") {
                                        history.push("/employee");
                                    }
                                }}
                                style={{ cursor: crumb === "Employees" ? "pointer" : "default" }}
                            >
                                {crumb}
                                {!isLast ? "  " : ""}
                            </span>
                        );
                    })}
                </div>
                 {validationError.length > 0 && (
                                    <div
                                        className="d-flex align-items-center justify-content-between"
                                        role="alert"
                                        style={{
                                            boxShadow: "0px 4px 10px 0px #0000001F",
                                            padding: "15px 10px",
                                            borderRadius: "12px",
                                            border: "1px solid #DC3545",   // red border
                                            backgroundColor: "#F8D7DA",    // light red background
                                            color: "#842029",              // dark red text
                                            fontSize: "12px",
                                            position: "fixed",
                                            top: "10px",
                                            width: "calc(100% - 20px)",
                                            maxWidth: "640px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            zIndex: 2000,
                                        }}
                                    >
                                        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                            <X size={16} />
                                            <strong>Fail to be created</strong>
                                        </div>
                                
                                        <X
                                            size={16}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setValidationError([])}
                                        />
                                    </div>
                                )}

                <div className='edit-organisation-info'>
                    <div className='edit-organisation-left'>
                        <h1>Add Employee</h1>
                    </div>
                    <div className='discard-save-organisation-right d-flex align-items-center gap-2'>
                        <button
                            className="dark-button"
                            type='button'
                            onClick={handleDiscard}
                        >
                            Discard
                        </button>
                        <DiscardConfirmationModal
                            isOpen={discardModalOpen}
                            onCancel={handleCancelDiscard}
                            onConfirm={handleDiscardConfirm}
                            entityName="Employee"  // 🔁 Change dynamically (e.g., “Category”, “Stock”)
                        />
                        <button
                            className="dark-border"
                            type='button'
                            onClick={handleSave}
                        >
                            Add Employee
                        </button>
                    </div>
                </div>

                <div className="info-section">
                    {/* ─── EMPLOYEE INFO CARD ─────────────────────────────────────────── */}
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Basic Info</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>


                                {/* ─── ROW 1: UPLOAD IMAGE & DEPARTMENT MULTI-SELECT ────────────── */}
                                <div className='row gappingcls-added'>
                                    {/* UPLOAD IMAGE COLUMN */}
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label className="form-label d-flex align-items-center gap-2">
                                                Upload Image <span className='error-color'>*</span>
                                                <Tooltip title="Upload Image" body="Supported formats: JPG, PNG (max 5MB)">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <div
                                                className="upload-container"
                                                onClick={handleBrowseClick}
                                                onDragOver={(e) => e.preventDefault()}
                                                onDragEnter={handleDragEnter}
                                                onDragLeave={handleDragLeave}
                                                onDrop={handleDrop}
                                                style={{
                                                    border: '2px dashed #ccc',
                                                    borderRadius: '4px',
                                                    padding: '3rem 1.5rem',
                                                    textAlign: 'center',
                                                    cursor: 'pointer',
                                                    position: 'relative',
                                                    width: '100%',
                                                    backgroundColor: isDragging ? '#FFFEF0' : '#fff', // Drag highlight
                                                    transition: 'background-color 0.3s ease',
                                                }}
                                            >
                                                {uploadedImage ? (
                                                    <div style={{ display: 'inline-block' }}>
                                                        <img
                                                            src={URL.createObjectURL(uploadedImage)}
                                                            alt="Preview"
                                                            style={{
                                                                maxWidth: '100%',
                                                                maxHeight: '150px',
                                                                objectFit: 'contain',
                                                                borderRadius: '4px',
                                                            }}
                                                        />
                                                        {/* “×” to remove image */}
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleRemoveImage();
                                                            }}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '6px',
                                                                right: '10px',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                borderRadius: '0',
                                                                cursor: 'pointer',
                                                                fontSize: '34px',
                                                                padding: 0,
                                                                lineHeight: '30px',
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="upload-placeholder">
                                                        {/* Cloud‐upload SVG icon */}
                                                        <CloudUpload />
                                                        <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
                                                            Drag your image here
                                                            or{' '}
                                                            <span style={{ color: '#007bff', textDecoration: 'underline' }}>
                                                                Browse
                                                            </span>
                                                        </p>
                                                    </div>
                                                )}

                                                {/* Hidden file input, triggered by clicking container */}
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={handleImageChange}
                                                    className={` ${errors.profile_image ? 'err-color' : ''}`}
                                                />
                                            </div>
                                            {errors.profile_image && <p style={{ color: 'red' }}>{errors.profile_image}</p>}
                                        </div>
                                    </div>

                                </div>

                                {/* ─── ROW 2: EMPLOYEE NAME & STATUS ───────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label
                                                htmlFor="contactNumber"
                                                className="form-label d-flex align-items-center gap-1"
                                            >
                                                Name <span className='error-color'>*</span>
                                                <Tooltip  title = "Name" body="Employee's name">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>

                                            <div style={{ display: 'flex', gap: '12px' }}>
                                                <input
                                                    type="text"
                                                    className={`form-control common-input-all  ${errors.employee_first_name ? 'err-color' : ''}`}
                                                    id="firstName"
                                                    placeholder="First Name"
                                                    name="employee_first_name"
                                                    value={formData.employee_first_name} onChange={handleChange}
                                                />
                                                <input
                                                    type="text"
                                                    className={`form-control common-input-all  ${errors.employee_last_name ? 'err-color' : ''}`}
                                                    id="lastName"
                                                    placeholder="Last Name"
                                                    name="employee_last_name"
                                                    value={formData.employee_last_name} onChange={handleChange}
                                                />
                                            </div>
                                            {errors.employee_first_name && <p style={{ color: 'red' }}>{errors.employee_first_name}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label htmlFor="status" className="form-label">
                                                Status <span className='error-color'>*</span>
                                            </label>
                                            <div className='flexing-type-radio'>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="status"
                                                        id="flexRadioDefault1"
                                                        value="1"
                                                        checked={formData.status === "1"} // Bind to formData.status
                                                        onChange={handleChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexRadioDefault1"
                                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                    >
                                                        Active
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="status"
                                                        id="flexRadioDefault2"
                                                        value="0"
                                                        checked={formData.status === "0"} // Bind to formData.status
                                                        onChange={handleChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="flexRadioDefault2"
                                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                                    >
                                                        Suspended
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* ─── ROW 3: Display NAME & Permission Group ─────────────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label
                                                htmlFor="displayName"
                                                className="form-label d-flex align-items-center gap-2"
                                            >
                                                Display Name
                                                <Tooltip  title="Display Name" body="A shorter, human-friendly label for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control common-input-all"
                                                id="displayName"
                                                placeholder="Entity Display Name"
                                                name="display_name"
                                                value={formData.display_name} onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner" ref={permissionGroupRef} style={{ position: 'relative' }}>
                                            <label className="form-label d-flex align-items-center gap-2">
                                                Permission Group
                                                <Tooltip  title="Permission Group" body="Select one or more permission groups for this employee">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>

                                            {/* CLOSED VIEW: tags + count + arrow */}
                                            <div
                                                className="select-box form-control common-input-all"
                                                onClick={togglePermissionGroup}
                                                style={{
                                                    padding: '0.5rem',
                                                    minHeight: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {selectedPermissionGroups.length > 0 ? (
                                                    selectedPermissionGroups.map((g) => (
                                                        <span
                                                            key={g.id}
                                                            className="tag"
                                                            style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}
                                                        >
                                                            {g.role_name}
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    removePermissionGroup(g.id);
                                                                }}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}
                                                            >
                                                                <X size={14} strokeWidth={3} />
                                                            </button>
                                                        </span>
                                                    ))
                                                ) : (
                                                    <span style={{ color: '#999', fontSize: '0.9rem' }}>
                                                        Select Permission Group
                                                    </span>
                                                )}

                                                {/* Selected count + Arrow (only right side aligned) */}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginLeft: 'auto',
                                                        gap: '0.25rem',
                                                        fontSize: '0.8rem',
                                                        color: '#666',
                                                    }}
                                                >
                                                    {selectedPermissionGroups.length > 0 && (
                                                        <span>{selectedPermissionGroups.length} selected</span>
                                                    )}
                                                    <ChevronDown
                                                        size={16}
                                                        style={{
                                                            transform: isPermissionGroupOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s',
                                                            userSelect: 'none',
                                                        }}
                                                    />
                                                </span>
                                            </div>

                                            {/* DROPDOWN PANEL */}
                                            {isPermissionGroupOpen && (
                                                <div
                                                    className="options-container"
                                                    style={{
                                                        border: '1px solid #6c757d',
                                                        borderRadius: '8px',
                                                        marginTop: '4px',
                                                        maxHeight: '270px',
                                                        overflowY: 'auto',
                                                        background: '#fff',
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        zIndex: 1000,
                                                        width: '100%',
                                                        boxShadow: '0px 1px 4px 0px #0000001A',
                                                    }}
                                                    onWheel={(e) => e.preventDefault()}
                                                >
                                                    {/* Search input with icon */}
                                                    <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                        <Search
                                                            size={18}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '18px',
                                                                transform: 'translateY(-50%)',
                                                                color: '#6C757D',
                                                                pointerEvents: 'none',
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="search-input select-box form-control common-input-all"
                                                            placeholder="Search..."
                                                            value={permissionGroupSearch}
                                                            onChange={(e) => setPermissionGroupSearch(e.target.value)}
                                                            style={{
                                                                width: '100%',
                                                                padding: '0.5rem 0.5rem 0.5rem 2rem',
                                                                fontSize: '0.9rem',
                                                                outline: 'none',
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Options list */}
                                                    <ul
                                                        className="options-list custom-check"
                                                        style={{
                                                            listStyle: 'none',
                                                            margin: 0,
                                                            padding: '1.25rem',
                                                        }}
                                                    >
                                                        {allPermissionGroups.map((g) => (
                                                            <li key={g.id} style={{ marginBottom: '0.5rem' }}>
                                                                <label
                                                                    className="option-item"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        fontSize: '0.9rem',
                                                                        fontWeight: 'normal',
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={
                                                                            selectedPermissionGroups.findIndex(
                                                                                (item) => item.id === g.id
                                                                            ) > -1
                                                                        }
                                                                        onChange={() => handlePermissionGroupCheckbox(g)}
                                                                        style={{ marginRight: '8px' }}
                                                                    />
                                                                    {g.role_name}
                                                                </label>
                                                            </li>
                                                        ))}

                                                        {filteredPermissionGroups.length === 0 && (
                                                            <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                                                No permission groups found
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>


                                </div>

                            </div> {/* end of grid-info-adding */}
                        </div> {/* end of info-content */}
                    </div> {/* end of info-card */}

                    {/* ─── Contact INFO CARD ─────────────────────────────────────────── */}
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Contact Info</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>
                                {/* ─── ROW 1: Work Email & Personal Email ─────────────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label
                                                htmlFor="workEmail"
                                                className="form-label d-flex align-items-center gap-1"
                                            >
                                                Work Email <span className='error-color'>*</span>
                                                <Tooltip  title="Work Email" body="Work email for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="email"
                                                className={`form-control common-input-all  ${errors.company_email ? 'err-color' : ''}`}
                                                id="workEmail"
                                                placeholder="Work Email"
                                                name="company_email"
                                                value={formData.company_email} onChange={handleChange}
                                            />
                                        </div>
                                        {errors.company_email && <p style={{ color: 'red' }}>{errors.company_email}</p>}
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label
                                                htmlFor="personalEmail"
                                                className="form-label d-flex align-items-center gap-1"
                                            >
                                                Personal Email
                                                <Tooltip  title="Personal Email" body="Personal email for your entity">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control common-input-all"
                                                id="personalEmail"
                                                placeholder="Personal Email"
                                                name="personal_email"
                                                value={formData.personal_email} onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                </div>
                                {/* ─── ROW 2: Contact Number ─────────────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner" ref={countryCodeRef} style={{ position: 'relative' }}>
                                            <label
                                                htmlFor="contactNumber"
                                                className="form-label d-flex align-items-center gap-1"
                                            >
                                                Contact Number <span className='error-color'>*</span>
                                                <Tooltip  title="Contact Number" body="Employee's mobile number">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <div style={{ display: 'flex', gap: '12px' }}>
                                                <div
                                                    className="select-box form-control common-input-all"
                                                    onClick={toggleCountryCode}
                                                    style={{
                                                        flex: '0 0 20%',
                                                        padding: '0.5rem',
                                                        minHeight: '40px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        flexWrap: 'wrap',
                                                        position: 'relative',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {/* <span
                                                        className="tag"
                                                        style={{
                                                            backgroundColor: '#FFEB00',
                                                            color: '#212529',
                                                            borderRadius: '16px',
                                                            padding: '4px 8px',
                                                            margin: '2px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            lineHeight: 'normal',
                                                        }}
                                                    > */}
                                                        {selectedCountryCode?.country_code || '+65'}
                                                        {/* <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                removeCountryCode();
                                                            }}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                marginLeft: '10px',
                                                                cursor: 'pointer',
                                                                fontSize: '16px',
                                                                padding: '0',
                                                                lineHeight: '14px',
                                                            }}
                                                        >
                                                            <X size={14} strokeWidth={3} />
                                                        </button>
                                                    </span> */}
                                                    <span
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginLeft: 'auto',
                                                            gap: '0.25rem',
                                                            fontSize: '0.8rem',
                                                            color: '#666',
                                                        }}
                                                    >
                                                        <ChevronDown
                                                            size={16}
                                                            style={{
                                                                transform: isCountryCodeOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                                transition: 'transform 0.2s',
                                                                userSelect: 'none',
                                                            }}
                                                        />
                                                    </span>
                                                </div>
                                                {isCountryCodeOpen && (
                                                    <div
                                                        className="options-container"
                                                        style={{
                                                            border: '1px solid #6c757d',
                                                            borderRadius: '8px',
                                                            marginTop: '4px',
                                                            maxHeight: '270px',
                                                            overflowY: 'auto',
                                                            background: '#fff',
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: 0,
                                                            zIndex: 1000,
                                                            width: '50%',
                                                            boxShadow: '0px 1px 4px 0px #0000001A',
                                                        }}
                                                        onWheel={(e) => e.preventDefault()}
                                                    >
                                                        <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                            <Search
                                                                size={18}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '18px',
                                                                    transform: 'translateY(-50%)',
                                                                    color: '#6C757D',
                                                                    pointerEvents: 'none',
                                                                }}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="search-input select-box form-control common-input-all"
                                                                placeholder="Search..."
                                                                value={countryCodeSearch}
                                                                onChange={(e) => setCountryCodeSearch(e.target.value)}
                                                                style={{
                                                                    width: '100%',
                                                                    padding: '0.5rem 0.5rem 0.5rem 2rem',
                                                                    fontSize: '0.9rem',
                                                                    outline: 'none',
                                                                }}
                                                            />
                                                        </div>
                                                        <ul
                                                            className="options-list custom-check"
                                                            style={{
                                                                listStyle: 'none',
                                                                margin: 0,
                                                                padding: '1.25rem',
                                                            }}
                                                        >
                                                            {filteredCountryCodes.length > 0 ? (
                                                                filteredCountryCodes.map((cc) => (
                                                                    <li key={cc.country_code_id} style={{ marginBottom: '0.5rem' }}>
                                                                        <label
                                                                            className="option-item"
                                                                            style={{
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                cursor: 'pointer',
                                                                                fontSize: '0.9rem',
                                                                                fontWeight: 'normal',
                                                                            }}
                                                                            onClick={() => handleCountryCodeSelect(cc)}
                                                                        >
                                                                            <input
                                                                                type="radio"
                                                                                className={`form-check-input  ${errors.country_code ? 'err-color' : ''}`}
                                                                                checked={selectedCountryCode?.country_code_id === cc.country_code_id}
                                                                                onChange={() => handleCountryCodeSelect(cc)}
                                                                                style={{ marginRight: '8px' }}
                                                                            />
                                                                            {cc.country_code} ({cc.country_name})
                                                                        </label>
                                                                    </li>
                                                                ))
                                                            ) : (
                                                                <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                                                    No country codes found
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                )}
                                                <input
                                                    type="tel"
                                                    className={`form-control common-input-all  ${errors.phone_number ? 'err-color' : ''}`}
                                                    id="contactNumber"
                                                    placeholder="Enter mobile number"
                                                    style={{ flex: '1' }}
                                                    name="phone_number"
                                                    value={formData.phone_number}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            {errors.phone_number && <p style={{ color: 'red' }}>{errors.phone_number}</p>}
                                            {errors.country_code && <p style={{ color: 'red' }}>{errors.country_code}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ─── Position INFO CARD ─────────────────────────────────────────── */}
                    <div className="info-card new-info-overflow-auto">
                        <div className="info-header">
                            <h4 className="info-title">Position Info</h4>
                        </div>
                        <div className="info-content d-block">
                            <div className='grid-info-adding'>
                                {/* ─── ROW 1: Department & Manager ─────────────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div
                                            className="info-inner"
                                            ref={deptRef}
                                            style={{ position: 'relative' }}
                                        >
                                            <label className="form-label d-flex align-items-center gap-2">
                                                Department <span className='error-color'>*</span>
                                                <Tooltip  title="Department" body="Select one or more departments for this employee">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>

                                            {/* CLOSED VIEW: tags + arrow */}
                                            <div
                                                className= {` select-box form-control common-input-all ${errors.departments ? 'err-color' : ''}`}
                                                onClick={toggleDept}
                                                style={{
                                                    padding: '0.5rem',
                                                    minHeight: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {selectedDepts.length > 0 ? (
                                                    selectedDepts.map((d) => (
                                                        <span
                                                            key={d.department_id}
                                                            className="tag"
                                                            style={{
                                                                backgroundColor: '#FFEB00',
                                                                color: '#212529',
                                                                borderRadius: '16px',
                                                                padding: '4px 8px',
                                                                margin: '2px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                fontSize: '12px',
                                                                fontWeight: '600',
                                                                lineHeight: 'normal',
                                                            }}
                                                        >
                                                            {d.short_name}
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    removeDept(d.department_id);
                                                                }}
                                                                style={{
                                                                    background: 'none',
                                                                    border: 'none',
                                                                    marginLeft: '20px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '16px',
                                                                    padding: '0',
                                                                    lineHeight: '14px',
                                                                }}
                                                            >
                                                                <X size={14} strokeWidth={3} />
                                                            </button>
                                                        </span>
                                                    ))
                                                ) : (
                                                    <span style={{ color: '#999', fontSize: '0.9rem' }}>
                                                        Select Department
                                                    </span>
                                                )}

                                                {/* Selected count */}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginLeft: 'auto',
                                                        gap: '0.25rem',
                                                        fontSize: '0.8rem',
                                                        color: '#666',
                                                    }}
                                                >
                                                    {selectedDepts.length > 0 && (
                                                        <span>{selectedDepts.length} selected</span>
                                                    )}
                                                    <ChevronDown
                                                        size={16}
                                                        style={{
                                                            transform: isDeptOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s',
                                                            userSelect: 'none',
                                                        }}
                                                    />
                                                </span>
                                            </div>

                                            {/* DROPDOWN PANEL (visible when isDeptOpen) */}
                                            {isDeptOpen && (
                                                <div
                                                    className="options-container"
                                                    style={{
                                                        border: '1px solid #6c757d',
                                                        borderRadius: '8px',
                                                        marginTop: '4px',
                                                        maxHeight: '270px',
                                                        overflowY: 'auto',
                                                        background: '#fff',
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        zIndex: 1000,
                                                        width: '100%',
                                                        boxshadow: '0px 1px 4px 0px #0000001A',
                                                    }}
                                                    onWheel={(e) => e.preventDefault()}
                                                >
                                                    {/* Search input with icon */}
                                                    <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                        <Search
                                                            size={18}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '18px',
                                                                transform: 'translateY(-50%)',
                                                                color: '#6C757D',
                                                                pointerEvents: 'none',
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="search-input select-box form-control common-input-all"
                                                            placeholder="Search..."
                                                            value={deptSearch}
                                                            onChange={(e) => setDeptSearch(e.target.value)}
                                                            style={{
                                                                width: '100%',
                                                                padding: '0.5rem 0.5rem 0.5rem 2rem',
                                                                fontSize: '0.9rem',
                                                                outline: 'none',
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Options list */}
                                                    <ul
                                                        className="options-list custom-check"
                                                        style={{
                                                            listStyle: 'none',
                                                            margin: 0,
                                                            padding: '1.25rem',
                                                        }}
                                                    >
                                                        {allDepartments.map((d) => (
                                                            <li key={d.department_id} style={{ marginBottom: '0.5rem' }}>
                                                                <label
                                                                    className="option-item"
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        cursor: 'pointer',
                                                                        fontSize: '0.9rem',
                                                                        fontWeight: 'normal',
                                                                    }}
                                                                    for={'department_'+d.department_id}
                                                                >
                                                                    <input
                                                                        type="checkbox"
                                                                        id={'department_'+d.department_id}
                                                                        className={`form-check-input  ${errors.departments ? 'err-color' : ''}`}
                                                                        checked={
                                                                            selectedDepts.findIndex(
                                                                                (item) => item.department_id === d.department_id
                                                                            ) > -1
                                                                        }
                                                                        onChange={() => handleDeptCheckbox(d)}
                                                                        style={{ marginRight: '8px' }}
                                                                        name="departments[]"
                                                                        value={d.department_id}
                                                                    />
                                                                    {d.short_name}
                                                                </label>
                                                            </li>
                                                        ))}

                                                        {/* If no departments match search */}
                                                        {allDepartments.length === 0 && (
                                                            <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                                                No departments found
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                            {errors.departments && <p style={{ color: 'red' }}>{errors.departments}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label
                                                htmlFor="manager"
                                                className="form-label d-flex align-items-center gap-1"
                                            >
                                                Manager <span className='error-color'>*</span>
                                                <Tooltip  title="Manager" body="Select manager for this employee">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                         <select
                                            className={`form-select new-form-select-cls ${errors.manager ? 'err-color' : ''}`}
                                            aria-label="Default select example"
                                            name="manager"
                                            value={formData.manager}
                                            onChange={handleChange}
                                            >
                                            <option value="">Select Manager</option>
                                            {selectManagers.length > 0 &&
                                                selectManagers.map((m) => (
                                                <option key={m.id} value={m.display_name}>
                                                    {m.display_name}
                                                </option>
                                                ))}
                                            </select>

                                        </div>
                                        {errors.manager && <p style={{ color: 'red' }}>{errors.manager}</p>}
                                    </div>
                                </div>
                                {/* ─── ROW 2: Entities & Workplace ─────────────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    {/* ─── ENTITIES MULTI-SELECT COLUMN ───────────────────────────── */}
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner" ref={entityRef} style={{ position: 'relative' }}>
                                            <label className="form-label d-flex align-items-center gap-2">
                                                Entities <span className='error-color'>*</span>
                                                <Tooltip  title="Entities" body="Select one or more entities">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <div className={`select-box form-control common-input-all ${errors.entities ? 'err-color' : ''}`} onClick={toggleEntity} style={{ padding: '0.5rem', minHeight: '40px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', position: 'relative', cursor: 'pointer' }}>
                                                {selectedEntities.length > 0 ? selectedEntities.map((e) => (
                                                    <span key={e.entity_id} className="tag" style={{ backgroundColor: '#FFEB00', color: '#212529', borderRadius: '16px', padding: '4px 8px', margin: '2px', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '600' }}>
                                                        {e.entity_short_name}
                                                        <button type="button" onClick={(e2) => { e2.stopPropagation(); removeEntity(e.entity_id); }} style={{ background: 'none', border: 'none', marginLeft: '20px', cursor: 'pointer', fontSize: '16px' }}>
                                                            <X size={14} strokeWidth={3} />
                                                        </button>
                                                    </span>
                                                )) : <span style={{ color: '#999', fontSize: '0.9rem' }}>Select Entities</span>}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginLeft: 'auto',
                                                        gap: '0.25rem',
                                                        fontSize: '0.8rem',
                                                        color: '#666',
                                                    }}
                                                >
                                                    {selectedEntities.length > 0 && (
                                                        <span>{selectedEntities.length} selected</span>
                                                    )}
                                                    <ChevronDown
                                                        size={16}
                                                        style={{
                                                            transform: isEntityOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s',
                                                            userSelect: 'none',
                                                        }}
                                                    />
                                                </span>
                                            </div>
                                            {isEntityOpen && (
                                                <div className="options-container" style={{ border: '1px solid #6c757d', borderRadius: '8px', marginTop: '4px', maxHeight: '270px', overflowY: 'auto', background: '#fff', position: 'absolute', top: '100%', left: 0, zIndex: 1000, width: '100%' }}>
                                                    <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                        <Search size={18} style={{ position: 'absolute', top: '50%', left: '18px', transform: 'translateY(-50%)', color: '#6C757D', pointerEvents: 'none' }} />
                                                        <input type="text" className="search-input select-box form-control common-input-all" placeholder="Search..." value={entitySearch} onChange={(e) => setEntitySearch(e.target.value)} style={{ width: '100%', padding: '0.5rem 0.5rem 0.5rem 2rem', fontSize: '0.9rem' }} />
                                                    </div>
                                                    <ul className="options-list custom-check" style={{ listStyle: 'none', margin: 0, padding: '1.25rem' }}>
                                                        {allEntities.map((e) => (
                                                            <li key={e.entity_id} style={{ marginBottom: '0.5rem' }}>
                                                                <label className="option-item" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.9rem' }}>
                                                                    <input type="checkbox" className="form-check-input " checked={selectedEntities.findIndex((item) => item.entity_id === e.entity_id) > -1} onChange={() => handleEntityCheckbox(e)} style={{ marginRight: '8px' }} />
                                                                    {e.entity_short_name}
                                                                </label>
                                                            </li>
                                                        ))}
                                                        {allEntities.length === 0 && (
                                                            <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                                                No entities found
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                            {errors.entities && <p style={{ color: 'red' }}>{errors.entities}</p>}
                                        </div>
                                    </div>

                                    {/* ─── WORKPLACE MULTI-SELECT COLUMN ───────────────────────────── */}
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner" ref={workplaceRef} style={{ position: 'relative' }}>
                                            <label className="form-label d-flex align-items-center gap-2">
                                                Workplace <span className='error-color'>*</span>
                                                <Tooltip  title="Workplace" body="Select one or more workplaces">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <div className={`select-box form-control common-input-all ${errors.workplaces ? 'err-color' : ''}`} onClick={toggleWorkplace} style={{ padding: '0.5rem', minHeight: '40px', display: 'flex', alignItems: 'center', flexWrap: 'wrap', position: 'relative', cursor: 'pointer' }}>
                                                {selectedWorkplaces.length > 0 ? selectedWorkplaces.map((w) => (
                                                    <span key={w.workplace_id} className="tag" style={{ backgroundColor: '#FFEB00', color: '#212529', borderRadius: '16px', padding: '4px 8px', margin: '2px', display: 'flex', alignItems: 'center', fontSize: '12px', fontWeight: '600' }}>
                                                        {w.workplace_short_name}
                                                        <button type="button" onClick={(e2) => { e2.stopPropagation(); removeWorkplace(w.workplace_id); }} style={{ background: 'none', border: 'none', marginLeft: '20px', cursor: 'pointer', fontSize: '16px' }}>
                                                            <X size={14} strokeWidth={3} />
                                                        </button>
                                                    </span>
                                                )) : <span style={{ color: '#999', fontSize: '0.9rem' }}>Select Workplace</span>}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginLeft: 'auto',
                                                        gap: '0.25rem',
                                                        fontSize: '0.8rem',
                                                        color: '#666',
                                                    }}
                                                >
                                                    {selectedWorkplaces.length > 0 && (
                                                        <span>{selectedWorkplaces.length} selected</span>
                                                    )}
                                                    <ChevronDown
                                                        size={16}
                                                        style={{
                                                            transform: isWorkplaceOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s',
                                                            userSelect: 'none',
                                                        }}
                                                    />
                                                </span>
                                            </div>
                                            {isWorkplaceOpen && (
                                                <div className="options-container" style={{ border: '1px solid #6c757d', borderRadius: '8px', marginTop: '4px', maxHeight: '270px', overflowY: 'auto', background: '#fff', position: 'absolute', top: '100%', left: 0, zIndex: 1000, width: '100%' }}>
                                                    <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                        <Search size={18} style={{ position: 'absolute', top: '50%', left: '18px', transform: 'translateY(-50%)', color: '#6C757D', pointerEvents: 'none' }} />
                                                        <input type="text" className="search-input select-box form-control common-input-all" placeholder="Search..." value={workplaceSearch} onChange={(e) => setWorkplaceSearch(e.target.value)} style={{ width: '100%', padding: '0.5rem 0.5rem 0.5rem 2rem', fontSize: '0.9rem' }} />
                                                    </div>
                                                    <ul className="options-list custom-check" style={{ listStyle: 'none', margin: 0, padding: '1.25rem' }}>
                                                        {allWorkplaces.map((w) => (
                                                            <li key={w.workplace_id} style={{ marginBottom: '0.5rem' }}>
                                                                <label className="option-item" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.9rem' }}>
                                                                    <input type="checkbox" className="form-check-input" checked={selectedWorkplaces.findIndex((item) => item.workplace_id === w.workplace_id) > -1} onChange={() => handleWorkplaceCheckbox(w)} style={{ marginRight: '8px' }} />
                                                                    {w.workplace_short_name}
                                                                </label>
                                                            </li>
                                                        ))}
                                                        {allWorkplaces.length === 0 && (
                                                            <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                                                No workplaces found
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                            {errors.workplaces && <p style={{ color: 'red' }}>{errors.workplaces}</p>}
                                        </div>
                                    </div>

                                </div>
                                {/* ─── ROW 3: Job Title & Onboard Date ─────────────────────────────────────── */}
                                <div className='row gappingcls-added'>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner" ref={jobTitleRef} style={{ position: 'relative' }}>
                                            <label
                                                htmlFor="jobTitle"
                                                className="form-label d-flex align-items-center gap-1"
                                            >
                                                Job Title <span className='error-color'>*</span>
                                                <Tooltip  title="Job Title" body="Select employee's job title">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <div
                                                className={`select-box form-control common-input-all ${errors.job_title ? 'err-color' : ''}`}
                                                onClick={toggleJobTitle}
                                                style={{
                                                    padding: '0.5rem',
                                                    minHeight: '40px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flexWrap: 'wrap',
                                                    position: 'relative',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {selectedJobTitle ? (
                                                    <span
                                                        className="tag"
                                                        style={{
                                                            backgroundColor: '#FFEB00',
                                                            color: '#212529',
                                                            borderRadius: '16px',
                                                            padding: '4px 8px',
                                                            margin: '2px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            lineHeight: 'normal',
                                                        }}
                                                    >
                                                        {selectedJobTitle.job_title_name}
                                                        <button
                                                            type="button"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                removeJobTitle();
                                                            }}
                                                            style={{
                                                                background: 'none',
                                                                border: 'none',
                                                                marginLeft: '10px',
                                                                cursor: 'pointer',
                                                                fontSize: '16px',
                                                                padding: '0',
                                                                lineHeight: '14px',
                                                            }}
                                                        >
                                                            <X size={14} strokeWidth={3} />
                                                        </button>
                                                    </span>
                                                ) : (
                                                    <span style={{ color: '#999', fontSize: '0.9rem' }}>
                                                        Select Job Title
                                                    </span>
                                                )}
                                                <span
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginLeft: 'auto',
                                                        gap: '0.25rem',
                                                        fontSize: '0.8rem',
                                                        color: '#666',
                                                    }}
                                                >
                                                    {selectedJobTitle && <span>1 selected</span>}
                                                    <ChevronDown
                                                        size={16}
                                                        style={{
                                                            transform: isJobTitleOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.2s',
                                                            userSelect: 'none',
                                                        }}
                                                    />
                                                </span>
                                            </div>
                                            {isJobTitleOpen && (
                                                <div
                                                    className="options-container"
                                                    style={{
                                                        border: '1px solid #6c757d',
                                                        borderRadius: '8px',
                                                        marginTop: '4px',
                                                        maxHeight: '270px',
                                                        overflowY: 'auto',
                                                        background: '#fff',
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        zIndex: 1000,
                                                        width: '100%',
                                                        boxShadow: '0px 1px 4px 0px #0000001A',
                                                    }}
                                                    onWheel={(e) => e.preventDefault()}
                                                >
                                                    <div style={{ padding: '0.5rem', position: 'relative' }}>
                                                        <Search
                                                            size={18}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                left: '18px',
                                                                transform: 'translateY(-50%)',
                                                                color: '#6C757D',
                                                                pointerEvents: 'none',
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="search-input select-box form-control common-input-all"
                                                            placeholder="Search..."
                                                            value={jobTitleSearch}
                                                            onChange={(e) => setJobTitleSearch(e.target.value)}
                                                            style={{
                                                                width: '100%',
                                                                padding: '0.5rem 0.5rem 0.5rem 2rem',
                                                                fontSize: '0.9rem',
                                                                outline: 'none',
                                                            }}
                                                        />
                                                    </div>
                                                    <ul
                                                        className="options-list custom-check"
                                                        style={{
                                                            listStyle: 'none',
                                                            margin: 0,
                                                            padding: '1.25rem',
                                                        }}
                                                    >
                                                        {filteredJobTitles.length > 0 ? (
                                                            filteredJobTitles.map((jt) => (
                                                                <li key={jt.job_title_id} style={{ marginBottom: '0.5rem' }}>
                                                                    <label
                                                                        className="option-item"
                                                                        style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            cursor: 'pointer',
                                                                            fontSize: '0.9rem',
                                                                            fontWeight: 'normal',
                                                                        }}
                                                                        onClick={() => handleJobTitleSelect(jt)}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            className="form-check-input"
                                                                            checked={selectedJobTitle?.job_title_id === jt.job_title_id}
                                                                            onChange={() => handleJobTitleSelect(jt)}
                                                                            style={{ marginRight: '8px' }}
                                                                        />
                                                                        {jt.job_title_name}
                                                                    </label>
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                                                No job titles found
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                            {errors.job_title && <p style={{ color: 'red' }}>{errors.job_title}</p>}
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 col-12'>
                                        <div className="info-inner">
                                            <label
                                                htmlFor="onboarddate"
                                                className="form-label d-flex align-items-center gap-1"
                                            >
                                                Onboard Date <span className='error-color'>*</span>
                                                <Tooltip  title="Onboard Date" body="Select the date when this employee was onboarded">
                                                    <Info size={16} className="info-icon" />
                                                </Tooltip>
                                            </label>
                                            <input
                                                type="date"
                                                className={`form-control common-input-all ${errors.onboard_date ? 'err-color' : ''}`}
                                                id="onboard_date"
                                                placeholder="Onboard Date"
                                                name="onboard_date"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={formData.onboard_date} onChange={handleChange}
                                            />
                                            {/* 
                                            <select
                                                className="form-select new-form-select-cls"
                                                aria-label="Default select example"
                                                name="onboard_date"
                                                value={formData.onboard_date} onChange={handleChange}
                                            >
                                                <option defaultValue>Select Onboard Date</option>
                                                <option value="1">Select Onboard Date One</option>
                                                <option value="2">Select Onboard Date Two</option>
                                                <option value="3">Select Onboard Date Three</option>
                                            </select>
                                             */}
                                        </div>
                                        {errors.onboard_date && <p style={{ color: 'red' }}>{errors.onboard_date}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ─── ADDITIONAL INFO CARD ─────────────────────────────────────────── */}
                    <div className="info-card">
                        <div className="info-header">
                            <h4 className="info-title">Additional Info</h4>
                        </div>
                        <div className="info-content">
                            <div className="info-inner common-textarea">
                                <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="form-label"
                                >
                                    Note
                                </label>
                                <textarea
                                    className="form-control w-100 common-textarea-all"
                                    id="exampleFormControlTextarea1"
                                    rows="3"
                                    name="notes"
                                    value={formData.notes} onChange={handleChange}
                                ></textarea>
                                
                            </div>
                        </div>
                    </div>
                </div> {/* end of info-section */}
            </div> {/* end of company-body */}
        </>
    );
}
